"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _material = require("@mui/material");
var _lodash = _interopRequireDefault(require("lodash"));
var _react = _interopRequireDefault(require("react"));
var _ListItemLink = _interopRequireDefault(require("../../components/ListItemLink"));
var _BannerLinkModule = _interopRequireDefault(require("./BannerLink.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const BannerLinks = _ref => {
  let {
    items,
    listItemProps,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_material.List, props, _lodash.default.map(items, _ref2 => {
    let {
      label,
      ...item
    } = _ref2;
    return /*#__PURE__*/_react.default.createElement(_material.ListItem, _extends({
      key: item.href
    }, listItemProps), /*#__PURE__*/_react.default.createElement(_ListItemLink.default, _extends({}, item, {
      className: _BannerLinkModule.default['banner-list-item-link'],
      sx: {
        justifyContent: 'right'
      }
    }), label));
  }));
};
BannerLinks.defaultProps = {
  dense: true,
  disablePadding: true,
  listItemProps: {
    disableGutters: true,
    disablePadding: true
  }
};
var _default = exports.default = BannerLinks;